import { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContext } from './ToastContext';
import './Login.css';

function Login({ whatsappUrl }) {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [emulatorInfo, setEmulatorInfo] = useState(null);
  const { addToast } = useContext(ToastContext);
  const navigate = useNavigate();

  useEffect(() => {
    const info = localStorage.getItem('emulatorInfo');
    if (!info) return;

    if (info === '[object Object]') {
      setEmulatorInfo({ __error: 'Emulator info was stored incorrectly (raw object). Please re-save it as JSON via localStorage.setItem("emulatorInfo", JSON.stringify(obj)).' });
      return;
    }

    try {
      const parsed = JSON.parse(info);
      setEmulatorInfo(parsed);
    } catch {
      setEmulatorInfo(info);
    }
  }, []);



  const setErrorWithVibrate = (msg) => {
    setError(msg);
    if (navigator.vibrate) navigator.vibrate(200);
  };

  const getLocationData = async () => {
    try {
      // Try IP-based geolocation first
      const ipResponse = await fetch('https://ipapi.co/json/');
      const locationData = await ipResponse.json();
      return locationData;
    } catch (err) {
      console.error('Location fetch error:', err);
      return null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!phoneNumber || !password) {
      setErrorWithVibrate('Please fill all fields');
      addToast('Please fill all fields', 'error');
      return;
    }

    if (phoneNumber.length !== 10) {
      setErrorWithVibrate('Phone number must be 10 digits');
      addToast('Phone number must be 10 digits', 'error');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // Get location data
      const locationData = await getLocationData();

      // Check if location is India
      // if (locationData && locationData.country_code !== 'IN') {
      //   const errorMessage = 'Service is only available in India';
      //   setError(errorMessage);
      //   addToast(errorMessage, 'error');
      //   setLoading(false);
      //   return;
      // }

      // Get emulator info (skip the corrupted "[object Object]" sentinel)
      const rawEmulatorInfo = localStorage.getItem('emulatorInfo');
      const emulatorInfoToSend =
        rawEmulatorInfo && rawEmulatorInfo !== '[object Object]'
          ? rawEmulatorInfo
          : null;

      let parsedEmulatorInfo = null;
      if (emulatorInfoToSend) {
        try {
          parsedEmulatorInfo = JSON.parse(emulatorInfoToSend);
        } catch {
          parsedEmulatorInfo = null;
        }
      }
      const isEmulator = parsedEmulatorInfo?.isEmulator === true
        || parsedEmulatorInfo?.isEmulator === 'true';

      const formData = new FormData();
      formData.append('contact_number', phoneNumber);
      formData.append('password', password);

      if (emulatorInfoToSend) {
        formData.append('emulator_info', emulatorInfoToSend);
        formData.append('isEmulator', String(isEmulator));
      }
      if (locationData) {
        formData.append('location_data', JSON.stringify(locationData));
        formData.append('country_code', locationData.country_code);
      }

      const response = await fetch('https://backend.mainbazar777.site/api/user/login', {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (data.success) {
        localStorage.setItem('user', JSON.stringify(data.user));
        if (data.token) {
          localStorage.setItem('token', data.token);
        }
        addToast('Login Successful!', 'success');

        if (
          data?.approved === false || data.user?.admin_approved === 0
        ) {
          window.location.href = 'https://dhanlaxmi365.xyz/v1/';
          return;
        } else if(data.user.admin_approved === 1) {
          setTimeout(() => {
            navigate('/');
          }, 1500);
        }else{
          const errorMessage = 'Login failed';
        setError(errorMessage);
        }
      } else {
        const errorMessage = data.message || 'Login failed';
        setErrorWithVibrate(errorMessage);
        addToast(errorMessage, 'error');
      }
    } catch (err) {
      console.error('Login error:', err);
      const errorMessage = 'Connection error. Please try again.';
      setErrorWithVibrate(errorMessage);
      addToast(errorMessage, 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleWhatsApp = () => {
    const url = whatsappUrl || 'https://wa.me/918000673615';
    window.location.href = url;
  };

  return (
    <div className="login-container">
      <div className="whatsapp-float-wrapper" onClick={handleWhatsApp}>
        <button className="whatsapp-float" aria-label="Chat on WhatsApp">
          <svg width="28" height="28" viewBox="0 0 48 48" fill="white">
            <path d="M4.9,43.3l2.7-9.8C5.9,30.6,5,27.3,5,24C5,13.5,13.5,5,24,5c5.1,0,9.8,2,13.4,5.6C41,14.2,43,18.9,43,24c0,10.5-8.5,19-19,19c0,0,0,0,0,0h0c-3.2,0-6.3-0.8-9.1-2.3L4.9,43.3z"/>
            <path fill="#40c351" d="M19.3,16c-0.4-0.8-0.7-0.8-1.1-0.8c-0.3,0-0.6,0-0.9,0s-0.8,0.1-1.3,0.6c-0.4,0.5-1.7,1.6-1.7,4s1.7,4.6,1.9,4.9s3.3,5.3,8.1,7.2c4,1.6,4.8,1.3,5.7,1.2c0.9-0.1,2.8-1.1,3.2-2.3c0.4-1.1,0.4-2.1,0.3-2.3c-0.1-0.2-0.4-0.3-0.9-0.6s-2.8-1.4-3.2-1.5c-0.4-0.2-0.8-0.2-1.1,0.2c-0.3,0.5-1.2,1.5-1.5,1.9c-0.3,0.3-0.6,0.4-1,0.1c-0.5-0.2-2-0.7-3.8-2.4c-1.4-1.3-2.4-2.8-2.6-3.3c-0.3-0.5,0-0.7,0.2-1c0.2-0.2,0.5-0.6,0.7-0.8c0.2-0.3,0.3-0.5,0.5-0.8c0.2-0.3,0.1-0.6,0-0.8C20.6,19.3,19.7,17,19.3,16z"/>
          </svg>
        </button>
        <span className="whatsapp-float-label">Support</span>
      </div>
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">DeepLaxmi</div>
          <h1>Welcome Back</h1>
          <p>Sign in to your account</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label>Phone Number</label>
            <div className="phone-input-wrapper">
              <span className="country-code">+91</span>
              <input
                type="tel"
                placeholder="Enter your 10-digit number"
                value={phoneNumber}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                  setPhoneNumber(value);
                }}
                maxLength="10"
              />
            </div>
          </div>

          <div className="form-group">
            <label>Password</label>
            <div className="password-input-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M1 12C1 12 5 5 12 5C19 5 23 12 23 12C23 12 19 19 12 19C5 19 1 12 1 12Z" stroke="currentColor" strokeWidth="2" />
                    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M3 3L21 21M10.584 10.587C10.2087 10.9621 10 11.4707 10 12C10 13.1046 10.8954 14 12 14C12.5293 14 13.0379 13.7913 13.413 13.416" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <path d="M9.513 5.73C10.316 5.57 11.157 5.5 12 5.5C19 5.5 23 12 23 12C22.5143 12.7462 21.9835 13.4435 21.404 14.085" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                )}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="login-btn"
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        {/* {emulatorInfo && (
          <div className="emulator-info-display" style={{
            marginTop: '16px',
            padding: '12px',
            backgroundColor: '#f5f5f5',
            borderRadius: '6px',
            fontSize: '12px',
            color: '#666',
            wordBreak: 'break-all',
            maxHeight: '100px',
            overflowY: 'auto',
            border: '1px solid #ddd'
          }}>
            <strong>Emulator Info:</strong>
            <div style={{ marginTop: '8px' }}>
              {typeof emulatorInfo === 'string'
                ? emulatorInfo
                : emulatorInfo.__error
                  ? emulatorInfo.__error
                  : JSON.stringify(emulatorInfo, null, 2)}
            </div>
          </div>
        )} */}

        <div className="login-footer">
          <p>Don't have an account? <button className="register-link" onClick={() => navigate('/register')}>Register</button></p>
        </div>
      </div>
    </div>
  );
}

export default Login;
